import { withInstall, withNoopInstall } from '@code-monkey-ui/utils'

import DshSelect from './src/select.vue'
import DshOption from './src/option.vue'
import DshOptionGroup from './src/option-group.vue'

export const ElDshSelect = withInstall(DshSelect, {
  DshOption,
  DshOptionGroup,
})
export default ElDshSelect
export const ElDshOption = withNoopInstall(DshOption)
export const ElDshOptionGroup = withNoopInstall(DshOptionGroup)

export * from './src/token'
